import { Injectable, Output, EventEmitter } from '@angular/core';
import { environment } from '../../environments/environment';
@Injectable({
  providedIn: 'root'
})


export class SharedService {
  @Output() navbar: EventEmitter<any> = new EventEmitter();
  modalConfig = {
    show: true, ignoreBackdropClick: true
  };
  baseURL: string = environment.url;
 // baseURL: string = 'https://localhost:44388';
  socialLinksData = [
    {
      key: 'Instagram',
      url: '',
      icon: 'https://sureassure.com/socialicon/instagram.png'

    },
    {
      key: 'Facebook',
      url: '',
      icon: 'https://sureassure.com/socialicon/facebook.png'

    },
    {
      key: 'LinkedIn',
      url: '',
      icon: 'https://sureassure.com/socialicon/linkedin.png'

    },
    {
      key: 'Pinterest',
      url: '',
      icon: 'https://sureassure.com/socialicon/pinterest.png'

    },
    {
      key: 'Snapchat',
      url: '',
      icon: 'https://sureassure.com/socialicon/snapchat.png'

    },
    {
      key: 'WhatsApp',
      url: '',
      icon: 'https://sureassure.com/socialicon/whatsapp.png'

    },
    {
      key: 'Youtube',
      url: '',
      icon: 'https://sureassure.com/socialicon/youtube.png'

    },
    {
      key: 'Twitter',
      url: '',
      icon: 'https://sureassure.com/socialicon/twitter.png'

    }
  ];
  constructor() { }
  refreshNavBar() {

    this.navbar.emit();
  }
}
